module.exports = __webpack_public_path__ + "static/media/arqmob.cb2d9f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquitetodenegocios/arqmob.png
// module id = 19
// module chunks = 0